module.exports = __webpack_public_path__ + "img/lugares-h.3dc9f7eb.png";